import {
  TABLE_COLUMN_SYSTEM_FIELDS_TRANSLATIONS,
  type TableColumnIdentifier,
  type TableColumnSystemField,
} from '@tempo-io/roadmap-dto';
import type { TFunction } from 'i18next';
import type { CustomField } from '@/common/api/types/customField';

export const getColumnName = (
  t: TFunction,
  columnIdentifier: TableColumnIdentifier,
  customField?: CustomField,
) => {
  if (columnIdentifier.type === 'customField') {
    return columnIdentifier.customFieldId &&
      customField &&
      columnIdentifier.customFieldId === customField.id
      ? customField.name
      : '';
  }

  const translationKey = TABLE_COLUMN_SYSTEM_FIELDS_TRANSLATIONS.get(
    columnIdentifier.type as TableColumnSystemField,
  );
  return translationKey
    ? t(($) => $.views.table.columns.systemFields[columnIdentifier.type as TableColumnSystemField])
    : '';
};
